// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useState, useContext, useRef} from 'react';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import {Trans as T, useTranslation} from 'react-i18next';
// @ts-ignore
import {default_qa} from './default_qa';
import {use_section_scroll} from '../lib/use_section_scroll';
import Icon_chevron_down from '../img/hola2023/icons/24/chevron_down.svg';
import './pricing_faq.module.less';

type i_answer = string|JSX.Element|(string|any)[];

interface i_trans {
    q?: string;
    a?: string;
}

interface i_pricing_qa_props {
    q?: string;
    a?: i_answer;
    loc?: boolean;
    trans?: i_trans;
}

export const Pricing_qa = (props: i_pricing_qa_props)=>{
    const {theme, theme_name} = useContext(Settings_context);
    const {t} = useTranslation() as any;
    const {q, a, loc, trans = {}} = props;
    const [opened, set_opened] = useState(false);
    const on_toggle = ()=>set_opened(!opened);
    const question = loc && trans.q ? t(trans.q) : q;
    const a_cls = theme_name=='hola2023' ? theme.p3 : theme.p2;
    const answer = loc && trans.a ?
        <T i18nKey={trans.a}
          components={{ul: <ul/>, li: <li/>, p: <p className={a_cls}/>}}/> :
        Array.isArray(a) ? a.map((s, i)=>typeof s == 'string' ?
            <p key={i} className={a_cls}>{s}</p> : s({i, ...props})) : a;
    const cls = cn('pricing_faq-qa', opened && 'opened');
    const q_cls = cn(theme.p2, theme_name=='hola2023' ? theme.med :
        theme.bold);
    return <div className={cls} onClick={on_toggle}>
      <div className="pricing_faq-q">
        <p className={q_cls}>{question}</p>
      </div>
      <div className="pricing_faq-a">{answer}</div>
      <button className="pricing_faq-toggle">{theme_name=='hola2023' &&
        <Icon_chevron_down width={24} height={24}/>}</button>
    </div>;
};

interface i_pricing_faq_props {
    qa?: {q?:string, a?:i_answer, trans?: i_trans}[];
    country?: string;
    shown?: boolean;
    cols?: number;
    white?: boolean;
    title?: string;
    subtitle?: string;
    loc?: boolean;
    cls?: string;
    visible?: boolean;
}

export const Pricing_faq = (props: i_pricing_faq_props)=>{
    const {theme_name} = useContext(Settings_context);
    const {t} = useTranslation() as any;
    const {qa = default_qa, country, shown, cols = 2, white, title =
        'Frequently asked questions', loc, visible, subtitle} = props;
    const r = useRef();
    use_section_scroll(r, undefined, {logic_disabled: !shown || visible});
    const qa_cols = (qa as any).reduce((acc, q, i)=>{
        const current = i % cols;
        if (!acc[current])
            acc[current] = [];
        acc[current].push(q);
        return acc;
    }, []);
    const title_text = loc ? t(title) : title;
    const cls = cn('pricing_faq-wrapper container', theme_name,
        `cols-${cols}`, props.cls);
    return <div className={cls}>
      <div className={cn('pricing_faq', {white})} ref={r}>
        {theme_name=='hola2023'
            ? <h4 className="pricing_faq-title">{title_text}</h4>
            : <h2 className="pricing_faq-title">{title_text}</h2>}
        {subtitle && <p className="pricing_faq-subtitle">
          {loc ? t(subtitle) : subtitle}</p>}
        <div className="pricing_faq-questions">
          {qa_cols.map((col_qa, col_i)=>
            <div className="pricing_faq-col" key={col_i}>
              {col_qa.map((q, i)=><Pricing_qa key={i} {...q}
                country={country} loc={loc}/>)}
            </div>)}
        </div>
      </div>
    </div>;
};
